import { useTranslation } from "react-i18next";
import { Input } from "antd";
import { OffsiteCampaignContextType } from "context/OffsiteCampaignProvider";
import RetailDrawer from "components/Drawer/RetailDrawer";
import RetailFormInput from "components/Form/RetailFormInput";
import RetailTitle from "components/Typography/RetailTitle";
import RetailText from "components/Typography/RetailText";
import cc from "classcat";
import cm from "./style.module.scss";

interface OffsiteEditAdDrawerProps {
  visible: boolean;
  onClose: () => void;
  disableOkButton: boolean;
  formFields: OffsiteCampaignContextType["formFields"];
  handleFormFieldsChange: (
    key: keyof OffsiteCampaignContextType["formFields"],
    value: string
  ) => void;
}

const OffsiteEditAdDrawer = ({
  visible,
  onClose,
  disableOkButton,
  formFields,
  handleFormFieldsChange,
}: OffsiteEditAdDrawerProps) => {
  const { t } = useTranslation();

  return (
    <RetailDrawer
      title={t("components.offsiteCampaignForm.firstStep.editAd")}
      visible={visible}
      onClose={onClose}
      onOk={onClose}
      width={700}
      disableOk={disableOkButton}
      placement="right"
      maskClosable={true}
      keyboard={true}
    >
      <RetailTitle level={5} className={cm.drawerTitle}>
        {t("components.offsiteCampaignForm.firstStep.adName")}
      </RetailTitle>
      <RetailText className={cm.drawerText} size="xxxs">
        {t("components.offsiteCampaignForm.firstStep.adNameText")}
      </RetailText>
      <RetailFormInput
        isFocused={formFields.adName !== ""}
        label={t("components.offsiteCampaignForm.firstStep.adName")}
        className="floating"
      >
        <Input
          className={cc(["floating", cm.drawerInput])}
          onChange={(e) => handleFormFieldsChange("adName", e.target.value)}
          value={formFields.adName}
        />
      </RetailFormInput>
      <RetailTitle level={5} className={cm.drawerTitle}>
        {t("components.offsiteCampaignForm.firstStep.primaryText")}
      </RetailTitle>
      <RetailText className={cm.drawerText} size="xxxs">
        {t("components.offsiteCampaignForm.firstStep.primaryTextText")}
      </RetailText>
      <RetailFormInput
        isFocused={formFields.primaryText !== ""}
        label={t("components.offsiteCampaignForm.firstStep.primaryText")}
        className="floating"
      >
        <Input
          className={cc(["floating", cm.drawerInput])}
          onChange={(e) =>
            handleFormFieldsChange("primaryText", e.target.value)
          }
          value={formFields.primaryText}
        />
      </RetailFormInput>

      <RetailTitle level={5} className={cm.drawerTitle}>
        {t("components.offsiteCampaignForm.firstStep.headline")}
      </RetailTitle>
      <RetailText className={cm.drawerText} size="xxxs">
        {t("components.offsiteCampaignForm.firstStep.headlineText")}
      </RetailText>
      <RetailFormInput
        isFocused={formFields.headline !== ""}
        label={t("components.offsiteCampaignForm.firstStep.headline")}
        className="floating"
      >
        <Input
          className={cc(["floating", cm.drawerInput])}
          onChange={(e) => handleFormFieldsChange("headline", e.target.value)}
          value={formFields.headline}
        />
      </RetailFormInput>

      <RetailTitle level={5} className={cm.drawerTitle}>
        {t("components.offsiteCampaignForm.firstStep.description")}
      </RetailTitle>
      <RetailText className={cm.drawerText} size="xxxs">
        {t("components.offsiteCampaignForm.firstStep.descriptionText")}
      </RetailText>
      <RetailFormInput
        isFocused={formFields.description !== ""}
        label={t("components.offsiteCampaignForm.firstStep.description")}
        className="floating"
      >
        <Input
          className={cc(["floating", cm.drawerInput])}
          onChange={(e) =>
            handleFormFieldsChange("description", e.target.value)
          }
          value={formFields.description}
        />
      </RetailFormInput>
    </RetailDrawer>
  );
};

export default OffsiteEditAdDrawer;
